// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1QpNF","inner":"Footer_inner__qfxKt"};